import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "white",
    padding: 10,
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
    flexDirection: "column",
  },
  image: {
    width: "150px",
    height: "auto",
    alignSelf: "center",
  },
  card: {
    width: "200px",
    height: "240px",
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
    margin: 0,
    padding: 2,
    border:"1px solid black"
  },
  row: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
  },
});

// Create Document Component
const MyDocument = ({ coopList, imageSrc }) => {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={{ display: "flex", flexDirection: "row", gap: 5 }}>
          {imageSrc !== "No Image" && <Image style={{width:"100px",height:"auto"}} src={imageSrc} />}

          <Text>{coopList?.nameEng}</Text>
          <Text>{coopList?.nameNep || "Co-operative Society"}</Text>
          <Text>{coopList?.addressEng}</Text>
        </View>
        <View>
          <Text>{coopList?.phoneNumberEng}</Text>
          <Text>{coopList?.email}</Text>
          <Text>{coopList?.website}</Text>
        </View>
        <View style={styles.section}>
          <Text>Executive Committee</Text>
          <View style={styles.row}>
            {coopList?.executiveCommittee?.map((item) => (
              <View style={styles.card} key={item.id}>
                <Image
                  style={styles.image}
                  src={`data:image/jpeg;base64,${item.image}`}
                />
                <Text style={{ paddingTop: 2 }}>{item.name}</Text>
                <Text>{item.designation}</Text>
              </View>
            ))}
          </View>
        </View>
        <View style={styles.section}>
          <Text>Lekha Suparibechan Committee</Text>
          <View style={styles.row}>
            {coopList?.lekhaSuparibechanCommittee?.map((item) => (
              <View style={styles.card} key={item.id}>
                <Image
                  style={styles.image}
                  src={`data:image/jpeg;base64,${item.image}`}
                />
                <Text style={{ paddingTop: 2 }}>{item.name}</Text>
                <Text>{item.designation}</Text>
              </View>
            ))}
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default MyDocument;
